module.exports = __webpack_public_path__ + "img/inicio-up.1813dcc7.svg";